var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mc", attrs: { id: "mc_" + _vm.parent.id } },
    [
      _vm._l(_vm.menus, function (menu) {
        return _vm.filterMenu(menu)
          ? [
              _c(
                "div",
                {
                  key: menu.id + "a",
                  class: _vm.getMenuClass(menu),
                  style: _vm.style,
                  attrs: { id: "menu_" + menu.id },
                  on: {
                    click: function ($event) {
                      return _vm.jump(menu)
                    },
                  },
                },
                [
                  _c("i", {
                    class: menu.icon || "iconmenu el-icon-menu-default",
                  }),
                  _vm._v(" " + _vm._s(menu.name) + " "),
                  _c("span"),
                ]
              ),
              _c("nav-menu-item", {
                key: menu.id + "b",
                attrs: { parent: menu, menus: _vm.menus },
                on: { setMenu: _vm.jump },
              }),
            ]
          : _vm._e()
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }